import React, { useEffect, useState } from 'react';
import {useParams} from "react-router-dom";
import {getGameById} from "../Queries/getById";
import {GameArticle, Image, TitleGame} from "../layout/Interface";
import {Field} from "../layout/Form";
import Swal from "sweetalert2"; 
import firebase from "../../firebase";

const GameScreen = ({history}) => {

    const {consoleGaming, id} = useParams();
    const [valueGame, setValue] = useState({});
    let {categorie, description, edition, imageUrl, priceOffer, name, offer, price, format, stock, console} = valueGame;
    const [imgUrl, setImageUrl] = useState("");

    const handleChange = (e) => {
        setValue({
            ...valueGame,
            [e.target.name]: e.target.value
        })
    }

    const onFileChange = async (e) => {
        const file = e.target.files[0];
        const storageRef = firebase.storage.ref();
        const fileRef = storageRef.child(file.name);
        await fileRef.put(file);
        setImageUrl(await fileRef.getDownloadURL());
    }

    const message = () => {
        Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Juego Actualizado Correctamente',
            showConfirmButton: false,
            timer: 1500
          })
    }


    const handleSubmit = async (e) => {
        e.preventDefault();
        let product = {
            name, console, price, offer, edition, priceOffer, stock, categorie, format, description, imageUrl
        }
        // console.log(product);
        await firebase.db.collection(consoleGaming).doc(id).update(product);
        message();
        if(categorie === "adventure"){
            categorie = "aventura"
        }
        else if(categorie === "action"){
            categorie = "accion"
        }
        else if(categorie === "sport"){
            categorie = "deporte"
        }
        history.push(`/categories/${categorie}`)
    }

    useEffect(() => {
        setValue({
            ...valueGame,
            imageUrl: imgUrl
        })
    }, [imgUrl])

    useEffect(async () => {
        const game = await getGameById(consoleGaming, id);
        setValue(game);
    }, []);
  
    return (
        <div className="bg-game">
            <div className="container">
                <h1 className = "title white">Editando Videojuego</h1>
                <div className="column-2">
                    <div className="flex-center mb-1">
                        <GameArticle>
                            <div className="flex-center">
                                <Image src = {imageUrl} />
                            </div>
                            <TitleGame   TitleGame>{name}</TitleGame>
                        </GameArticle>
                    </div>
                    <div className="form-camp">
                        <h2 className = "white title">Formulario para Editar</h2>
                        <form onSubmit = {handleSubmit} className = "mt-5">
                            <div className="flex-center-column">
                                {/* <Fieldset> */}
                                    {/* <Legend>Información Principal</Legend> */}
                                    <Field>
                                        <label htmlFor="">Nombre:</label>
                                        <input type="text" name = "name" onChange  ={handleChange} value = {name}/>
                                    </Field>
                                    <Field>
                                        <div className="flex-wrap">
                                            <label htmlFor="">Imagen: </label>
                                            <input type="file" onChange = {onFileChange}/>
                                        </div>
                                    </Field>
                                    <Field>
                                        <label htmlFor="">Consola:</label>
                                        <select name="console" onChange ={handleChange} className = "ml-5" value = {console}>
                                            <option  defaultValue >--Seleccione una opción--</option>
                                            <option value="ps4">PS4</option>
                                            <option value="ps5">PS5</option>
                                            <option value="switch">Switch</option>
                                        </select>
                                    </Field>
                                    <Field>
                                    <label htmlFor="">Categoría:</label>
                                    <select className = "ml-5" name = "categorie" onChange ={handleChange} value = {categorie}>
                                    <option  defaultValue >--Seleccione una opción--</option>
                                        <option value="action">Acción</option>
                                        <option value="terror">Terror</option>
                                        <option value="sport">Deporte</option>
                                        <option value="adventure">Aventura</option>
                                    </select>
                                    </Field>
                                    <Field>
                                        <label htmlFor="">En Stock:</label>
                                        <select name="stock" className = "ml-5" onChange = {handleChange} value  = {stock}>
                                            <option  defaultValue >--Seleccione una opción--</option>
                                            <option value="yes">Sí</option>
                                            <option value="no">No</option>
                                        </select>
                                    </Field>
                                    <Field>
                                        <label htmlFor="">Precio normal:</label>
                                        <input type="number" name = "price" onChange ={handleChange} value = {price}/>
                                    </Field>
                                {/* </Fieldset> */}
                                {/* <Fieldset> */}
                                    {/* <Legend>Información Extra</Legend> */}
                                    <Field>
                                        <label htmlFor="">Oferta: </label>
                                        <select name="offer" onChange ={handleChange} value = {offer}>
                                        <option  defaultValue >--Seleccione una opción--</option>
                                            <option value="yes">Sí</option>
                                            <option value="no">No</option>
                                        </select>
                                    </Field>
                                    <Field>
                                        <label htmlFor="">Edición: </label>
                                        <select name="edition" onChange ={handleChange} value = {edition}>
                                        <option  defaultValue >--Seleccione una opción--</option>
                                            <option value="normal">Normal</option>
                                            <option value="deluxe">Deluxe</option>
                                            <option value="premium">Premium</option>

                                        </select>
                                    </Field>
                                    <Field>
                                        <label htmlFor="">Precio con oferta: </label>
                                        <input type="number" name = "priceOffer" onChange ={handleChange} value = {priceOffer}/>
                                    </Field>
                                    <Field>
                                        <label htmlFor="">Disponible en:</label>
                                        <select className = "ml-5"name = "format" onChange ={handleChange} value = {format}>
                                        <option  defaultValue >--Seleccione una opción--</option>
                                            <option value="fisic">Fisico</option>
                                            <option value="digital">Digital</option>
                                            <option value="both">Ambos</option>
                                        </select>
                                    </Field>
                                    <Field>
                                        <label htmlFor="" className = "block">Descripción del juego:</label>
                                        <textarea name="description"onChange ={handleChange} value = {description} ></textarea>
                                    </Field>
                                {/* </Fieldset> */}
                                <div className="flex-center">
                                    <input type="submit" className = "btn-submit" value = "Guardar Cambios"/>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

    );
}
 
export default GameScreen;